import React, {useEffect, useState} from "react";

import ArrowIcon from "../../icons/arrow-icon";
import BurgerMenuIcon from "../../icons/burger-icon";
import Chart from "./_Chart";
import db from "../../services/query";

const StatsChartItem = ({
  headTitle,
  innerRef,
  draggableProps,
  dragHandleProps,
  route,
  drpData,
}) => {
  const [open, setOpen] = useState(true);
  const [facultyId, setFacultyId] = useState('');
  const [data, setData] = useState([]);

  const filterData = (e) => {
    setFacultyId(e.target.value);
  }

  useEffect(() => {
    const ac = new AbortController();

    requestData({ facultyId });

    return () => ac.abort();
  }, [facultyId]);

  const requestData = async ({ facultyId }) => {
    try {
      let url = facultyId ? `${route}?faculty_id=${facultyId}` : route
      db.getAll(url).then(({ data: { data } }) => setData(data));
    } catch (e) {
      setData([]);
    }
  };


  return (
    <div
      className={`chart-list ${open && "open"}`}
      {...dragHandleProps}
      {...draggableProps}
      ref={innerRef}
    >
      <div className="head">
        <button className="drag-btn">
          <BurgerMenuIcon />
        </button>
        <p>{headTitle}</p>
        <button className="slide-toggle" onClick={() => setOpen(!open)}>
          <ArrowIcon />
        </button>
      </div>
      <div className="body">
        <div className="main-chart-area">
          <Chart data={data} />
        </div>
        <div className="year-count-area">
          {drpData &&
            <select onChange={filterData}>
              <option value="">همه</option>
              {drpData?.map(option => <option key={option?.id} value={option?.id}>{option?.name}</option>)}
            </select>
          }
          <ul>
            {data?.map(data => (<li key={data?.entry_year || data?.year}>
              <b>{data?.student_count || data?.class_count || data?.staff_count || data?.teacher_count}</b>
              <p>{data?.entry_year || data?.year}</p>
            </li>))}
          </ul>

        </div>
      </div>
    </div>
  );
};

export default StatsChartItem;
